import React, { useState } from "react";
import { Task, TaskType } from "../../../types";
import { Button } from "@bandit-network/react-ui-kit";
import {
  CheckCircledIcon,
  ExternalLinkIcon,
  ReloadIcon,
} from "@radix-ui/react-icons";
import { getTarget, getUrl } from "../../../utils";
import { useQuestContext } from "../../../context/QuestContext";
import { replaceHyperlinks } from "../../../utils/hyperlink";
import useUser from "../../../hooks/useUser";
import { useConnect } from "@bandit-network/react-wallet-kit";

export interface InviteProps {
  data: Task;
}

const Invite: React.FC<InviteProps> = ({ data }) => {
  const [isVisited, setIsVisited] = useState(false);
  const { tasksCompleted } = useQuestContext();
  const { signature, address } = useConnect();
  const { user, onDiscordConnect, isUserLoading, showRefresh, fetchUser } =
    useUser();

  const onClick = () => {
    setIsVisited(true);
    const url = getUrl(TaskType.DISCORD_JOIN, data.args.discordInviteLink);
    setTimeout(() => {
      window.open(url, getTarget(), "height=600,width=600");
    }, 100);
    setTimeout(() => {
      setIsVisited(false);
    }, 7500);
  };

  const isTaskComplete = tasksCompleted.includes(data?.id);
  return (
    <div className="bad-quest__task">
      <p className="bad-quest__task--description">
        {replaceHyperlinks(data.description)}
      </p>
      {user?.socialmedia?.discord ? (
        <Button
          size="sm"
          className="bad-quest__task--action_button"
          onClick={onClick}
          disabled={isTaskComplete || isVisited}
        >
          {isTaskComplete ? `Completed` : isVisited ? "Joining..." : `Join`}
          {isTaskComplete ? (
            <CheckCircledIcon className="bad-quest__task--check_icon" />
          ) : null}
        </Button>
      ) : (
        <div className="flex items-center">
          <Button
            size="sm"
            className="bad-quest__task--action_button"
            onClick={onDiscordConnect}
            disabled={isTaskComplete || !signature?.data || isUserLoading}
          >
            {isUserLoading ? `Connecting...` : `Connect Discord`}
          </Button>
          {showRefresh && (
            <ReloadIcon
              className={`ml-2 mt-2 cursor-pointer bad-quest_action_button-reload${
                !isUserLoading ? "-stop" : ""
              }`}
              onClick={fetchUser}
            />
          )}
        </div>
      )}
    </div>
  );
};

export { Invite };
